import { DataExtensionField, DataExtensionPermission } from '../../services';

export function includesAllReadPermissions(
  field: DataExtensionField,
  requiredPermissions: DataExtensionPermission[],
): boolean {
  return requiredPermissions.every((permission) =>
    field['x-wix-permissions'].read.includes(permission),
  );
}
